import { useFragment } from 'react-relay';
import { taglineLinkFragment } from './TaglineLink.relay';
import type { TaglineLinkPropsType } from './types';

const TaglineLink: React.FC<TaglineLinkPropsType> = (props: TaglineLinkPropsType) => {
  const tagLineLink = useFragment(taglineLinkFragment, props.tagLineLink);

  return (
    <div className="min-h-[200px]">
      <a href={tagLineLink.url} target="_blank" rel="noreferrer">
        <h4 className="text-xs mb-3 uppercase text-accent">{tagLineLink.tagline}</h4>
        <h5>{tagLineLink.title}</h5>
        <span className="tagline-link__text">{tagLineLink.text}</span>
      </a>
    </div>
  );
};

export { TaglineLink };
